import { Title } from "@solidjs/meta";
import { H1 } from "@biketravel/solid-ui";

export const NotFoundPage = () => (
    <>
        <Title>Страница не найдена</Title>
        <H1>Страница не найдена</H1>
    </>
);